<template>
    <div>
        <div class="dropdown-divider"></div>
        <li class="p-2 d-flex">
            <div class="container-fluid">
                <div class="row justify-content-start">
                    <div class="col d-flex">
                        <InfoToolTip class="mr-2" :info="info" />
                        <p class="mb-0 font-weight-bold">Aperturas totales</p>
                    </div>
                    <div v-if="etiqueta" class="col d-flex align-items-center">
                        <p class="mb-0 font-weight-bold mr-3">
                            {{ n }}
                        </p>
                        <p class="badge text-white p-1 mb-0 badge-primary">
                            {{ nEtiqueta }}
                        </p>
                    </div>
                    <div v-else class="col d-flex">
                        <p class="mb-0 font-weight-bold mr-3">
                            {{ n }}
                        </p>
                    </div>
                </div>
            </div>
        </li>
    </div>
</template>

<script>
    import InfoToolTip from '../../../../../common/InfoToolTip.vue';

    export default {
        props: ['n', 'nEtiqueta', 'etiqueta'],
        components: {
            InfoToolTip
        },
        data() {
            return {
                info: 
                    `<p>Muestra cuántas veces se ha abierto un correo.
            <p><b>Totales:</b> Nº de aperturas totales entre todos los correos(un usuario puede abrir
                varias veces al mismo correo)
            </p>
            <p>
                <b>Únicas:</b> Nº de emails abiertos de todos los emails entregados</p>`,
            }
        }
    };
</script>
